import { CheckoutPagePreview } from "./CheckoutPagePreview";
import { MobileFixedOnTopPreview } from "./MobileFixedOnTopPreview";

export const ModalPreview = Object.assign(CheckoutPagePreview, {
  CheckoutPagePreview,
  MobileFixedOnTopPreview,
});
